import React, { useMemo } from 'react'
import { createSimpleMemoryRouter } from '@workwhile/ui'
import { Import } from './components/Import/Import'
import { Review } from './components/Review/Review'
import { Done } from './components/Done/Done'

export const useBulkCreateShiftsRouter = () => {
  const router = useMemo(() => {
    const router = createSimpleMemoryRouter({
      routes: [
        {
          path: 'import',
          element: <Import />,
          state: {
            title: 'Import',
          },
        },
        {
          path: 'review',
          element: <Review />,
          state: {
            title: 'Review & Confirm',
          },
        },
        {
          path: 'done',
          element: <Done />,
          state: {
            title: 'Done',
          },
        },
      ],
      initialEntries: ['import'],
    })
    return router
  }, [])

  return router
}
